// extracted by mini-css-extract-plugin
module.exports = {"label":"DownloadCsvModal__label--3BHRI","note":"DownloadCsvModal__note--2eY4y","checkboxWrapper":"DownloadCsvModal__checkboxWrapper--172yk"};